import { createContext } from "react";

interface MetaType {
  origin: string;
  address_id?: number;
  period_id?: number;
  order_id?: number;
}

export const CreditContext = createContext<{
  isCreditModalOpen: boolean;
  setCreditModalOpen: (val: boolean, meta?: MetaType) => void;
  setPrefilledValue?: (val: number) => void;
  prefilledValue?: number;
  meta?: Partial<MetaType>;
}>({
  isCreditModalOpen: false,
  setCreditModalOpen: () => {},
  setPrefilledValue: () => {},
  prefilledValue: null,
  meta: {},
});
